import axios from 'axios'
import Vue from 'vue'

const service = axios.create({
  // 서버 도메인 설정
  baseURL: process.env.BASE_API,
  // 요청 타임아웃 시간 설정
  timeout: 5000
})

// HTTP 요청 인터셉터
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// HTTP 응답 인터셉터
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.log('request.js - ' + error.response.data.message)

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/http/module/request.js